import {Component, EventEmitter, Output} from '@angular/core';
import {Events, NavController, NavParams, Tabs} from 'ionic-angular';
import {ShopPage} from '../shop/shop';
import {HttpClient} from '@angular/common/http';
import {ApiErrorHandlerProvider} from '../../providers/api-error-handler/api-error-handler';

/**
 * Generated class for the TrendingCutPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-trending-cut',
    templateUrl: 'trending-cut.html',
})
export class TrendingCutPage {
    errors: {};
    loading: boolean;
    tuid: string;
    trendingCuts: any;
    trendingCut: any;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public events: Events,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
    ) {
        this.trendingCuts = navParams.get('trendingCuts');
        this.trendingCut = navParams.get('trendingCut');
    }

    ionViewWillEnter(){
      this.tuid = localStorage.getItem('tuid');
      this.trendingCut.favorite = this.userHasTrendingCut();
    }

    userHasTrendingCut() {
        return this.trendingCut.user_ids.includes(parseInt(this.tuid));
    }

    toggleTrendingCutFavourite(trendingCut) {

        if (!this.tuid){
          let tabBar: Tabs = this.navCtrl.parent;
          localStorage.setItem('refer', String('2'));
          tabBar.select(5);
          return;
        }

        if (trendingCut.favorite === true) {
            trendingCut.favorite = false;
            this.trendingCut = trendingCut;
            this.trendingCut.user_ids.push(parseInt(this.tuid));
            this.events.publish('trendingCuts:favourite-', trendingCut);
        } else {
            trendingCut.favorite = true;
            this.trendingCut = trendingCut;
            this.trendingCut.user_ids.push(parseInt(this.tuid));
            this.events.publish('trendingCuts:favourite+', trendingCut);
        }

        this.updateTrendingCutFavourite(trendingCut);
    }

    updateTrendingCutFavourite(trendingCut) {
        return new Promise((resolve, reject) => {
            this.http
                .put(
                    `/trending-cuts/user/${this.tuid}/trending-cut/${trendingCut.id}`,
                    {
                        user: this.tuid,
                        teamTrendingCut: trendingCut.id,
                    },
                )
                .subscribe(
                    (trendingCuts: Array<any>) => {
                        resolve(trendingCuts);
                        this.events.publish('trendingCuts:refresh');
                    },
                    (error) => {
                        this.errors = this.apiErrorHandler.handleError(error);
                    },
                );
        });
    }

    openPage(event: any, shopId: any) {
        this.navCtrl.push(ShopPage, {
            shopId: shopId,
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/trending-cut/trending-cut.ts